import { combineEpics } from 'redux-observable';
import DataSourceCreateEpic from './DataSourceCreateEpic';
export const rootEpic = combineEpics(DataSourceCreateEpic);
export default rootEpic;

//# sourceMappingURL=epics.js.map
